import jwt_decode from "jwt-decode";
import { config } from "../../config";
import { getFromLocalStorage} from "../utility";

export const getJWT = () => getFromLocalStorage(config.jwtToken);

export const isExpired = (jwt) => jwt.exp <= Date.now() / 1000;

export const isAuthenticated = () => {
  const token = getJWT();
  try {
    return token && !isExpired(jwt_decode(token));
  } catch {
    return false;
  }
};

export const withJwtHeader = (token?: string) => ({
    Authorization: `bearer ${token ? token : getJWT()}`,
});